module.exports = __webpack_public_path__ + "img/00021.18f9ecb6.webp";